import React from "react"
import styled from "styled-components"
import { RiWhatsappFill } from "react-icons/ri"
import { Button } from "../../botonFormulario/style"
import { Hero } from "./style"

const WHATSAPP_URL =
  "https://api.whatsapp.com/send?phone=51945440268&text=Hola%20INTRAMET:%20Deseo%20ponerme%20en%20contacto%20con%20un%20representante."

const CtaLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #25d366;
  color: #fff;
  font-family: "aller";
  font-weight: bold;
  font-size: 1.2rem;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  margin-top: 1rem;

  .icon {
    font-size: 1.5rem;
  }

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    color: #fff;
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
`
const hero = props => {

  return (
    <Hero>
      <div data-aos="flip-up" data-aos-duration="1500" className="container">
        <div className="image-flex">
          <img src={props.img} alt="hero olympo" />
        </div>

        <div className="info">
          <h1>{props.title || "undefined"}</h1>
          <h2>{props.subtitle || "undefined"}</h2>
          <p dangerouslySetInnerHTML={{ __html: props.text }} />
          <p className="text-hero-especial">
            *Las especificaciones y/o características técnicas descritas están
            sujetas a variación por el fabricante sin previo aviso.
          </p>

          <div className="actions">
            <a
              className="btn-dark-alt2"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <RiWhatsappFill className="icon" />
              COTIZAR POR WHATSAPP
            </a>
            {props.href ? (
              <a
                href={props.href}
                className="btn-dark-alt2"
                onClick={() => props.setModal(!props.modal)}
              >
                Ver Video
              </a>
            ) : null}
          </div>

          {/* Specs antigua ocultada temporalmente
          <h3 className="titleCaracteristicas">
            ESPECIFICACIONES T&Eacute;CNICAS
          </h3>
          <div className="caracteristicas">
            <div className="col1">
              <h4>CAPACIDAD PASAJEROS</h4>
              <h4>LARGO</h4>
              <h4>ANCHO </h4>
              <h4>ALTURA</h4>
              <h4>CHASIS DISPONIBLES</h4>
            </div>
            <div className="col2">
              <p>{props.crText1 || "undefined"}</p>
              <p>{props.crText2 || "undefined"}</p>
              <p>{props.crText3 || "undefined"}</p>
              <p>{props.crText4 || "undefined"}</p>
              <p>{props.crText5 || "undefined"}</p>
            </div>
          </div>
          */}

          {props.chasisData && (
            <>
              <h3 className="titleCaracteristicas">
                ESPECIFICACIONES T&Eacute;CNICAS
              </h3>
              <div className="chasisTable">
                <table>
                  <tbody>
                    {props.chasisGroups && (
                      <tr className="groupRow">
                        <th></th>
                        {props.chasisGroups.map((group, idx) => (
                          <th key={idx} colSpan={group.span}>{group.label}</th>
                        ))}
                      </tr>
                    )}
                    {props.chasisData.map((row, idx) => (
                      <tr key={idx}>
                        <th>{row.label}</th>
                        {row.values.map((val, i) => (
                          <td key={i}>{val}</td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </Hero>
  )
}
export default hero
